import React from 'react';
import { Datetime, DatetimeProps } from '@fx-ui/fine-design';
import classNames from 'classnames';

interface IDatetimeProps extends DatetimeProps {
    isView?: boolean; // 预览模式
}

const CustomDatetime: React.FC<IDatetimeProps> = (props) => {
    const { className, isView } = props;

    return (
        <Datetime
            {...props}
            className={classNames('fx-custom-datetime', className, {
                'is-view': isView
            })}
        />
    );
};

export default CustomDatetime;
